export const SentryTest = () => {
  return (
    // eslint-disable-next-line no-undef
    <button onClick={() => methodDoesNotExist999()}>Break the world</button>
  )
}
